import React from 'react';
import { Helmet } from 'react-helmet';

const PlatformRegulation: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Regulament platformă</title>
      </Helmet>

      <div className="space-y-6">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Regulament platformă</h1>
          <p className="text-sm text-muted-foreground">Ultima actualizare: 12 februarie 2026</p>
        </div>

        <div className="rounded-lg border border-border bg-card p-4 text-sm">
          <div className="font-semibold">Operator / Furnizor</div>
          <div className="mt-2 space-y-1 text-muted-foreground">
            <div>
              <span className="text-foreground">Global Linknet SRL</span>
            </div>
            <div>Sediu: județul Argeș, Pitești, Str. Dorobanților, nr. 14, bl. 51, et. 1, ap. 8</div>
            <div>Registrul Comerțului: J03/1287/2023</div>
            <div>CUI: 48291648</div>
            <div>
              E-mail: <span className="text-foreground">office@globallinknet.ro</span>
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-border bg-muted p-4 text-sm text-muted-foreground">
          Acest regulament stabilește reguli de conduită și utilizare pentru Platformă (chat, comunitate, bibliotecă,
          catalog, calendar, clasă online și resurse). Regulile Platformei se aplică împreună cu regulile interne ale
          unității de învățământ și cu Termenii și condițiile.
        </div>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">1. Scop și aplicabilitate</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Regulamentul se aplică tuturor utilizatorilor și tuturor funcționalităților Platformei, indiferent de planul
              de acces (Free/Basic/Full) sau de tipul implementării (B2C/B2B).
            </li>
            <li>
              În cazul utilizatorilor minori, părinții/tutorii și unitatea de învățământ au un rol esențial în supravegherea
              utilizării.
            </li>
            <li>
              Platforma poate fi folosită doar pentru activități educaționale și comunicare școlară. Utilizarea în scopuri
              comerciale, politice sau publicitare neautorizate este interzisă.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">2. Roluri și responsabilități</h2>
          <div className="space-y-3 text-muted-foreground">
            <p>
              Platforma poate include roluri precum: elev, părinte/tutore, profesor, administrator de școală, superadmin
              (platformă/școală). Drepturile diferă în funcție de rol și de contextul școlar.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <span className="text-foreground">Elev</span>: folosește instrumentele pentru învățare, comunicare și acces
                la catalog, cu respectarea regulilor de conduită.
              </li>
              <li>
                <span className="text-foreground">Părinte/Tutore</span>: monitorizează progresul, comunică civilizat și
                protejează accesul la conturile copilului.
              </li>
              <li>
                <span className="text-foreground">Profesor</span>: gestionează conținut educațional, comunicare, evaluări și
                interacțiuni, respectând confidențialitatea și standardele profesionale.
              </li>
              <li>
                <span className="text-foreground">Administratori</span>: au obligația de a utiliza accesul administrativ
                doar în scop de operare, securitate și conformitate, fără abuz sau acces nejustificat.
              </li>
            </ul>
          </div>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">3. Reguli generale de conduită</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>Respect, limbaj adecvat și comunicare civilizată (fără jigniri, amenințări, hărțuire).</li>
            <li>
              Interzis: conținut ilegal, discriminatoriu, sexual explicit, violent, instigator la ură, defăimător sau
              care promovează auto-vătămarea.
            </li>
            <li>
              Nu publica date personale ale altora (ex.: numere de telefon, adrese, CNP, date bancare), note/absențe ale
              altor elevi sau capturi din Platformă fără un temei legitim.
            </li>
            <li>
              Nu încerca să ocolești limitările tehnice, să exploatezi vulnerabilități sau să accesezi resurse pentru care
              nu ai drepturi.
            </li>
            <li>
              Respectă drepturile de autor: nu încărca materiale piratate și nu redistribui resurse fără permisiune.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">4. Conturi, identitate și acces</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Contul este personal. Nu partaja credențiale și nu folosi contul altcuiva. Dacă suspectezi acces neautorizat,
              schimbă parola și anunță administratorul.
            </li>
            <li>
              Datele de profil trebuie să fie reale și adecvate mediului școlar. Nu folosi nume sau imagini ofensatoare.
            </li>
            <li>
              Pentru protecția minorilor, pot exista reguli suplimentare privind modul de creare/gestionare a conturilor în
              relație părinte–elev.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">5. Comunicare (chat) – mesaje și fișiere</h2>
          <div className="space-y-3 text-muted-foreground">
            <p>
              Chatul este destinat comunicării educaționale. Nu transforma conversațiile în canale de spam, marketing,
              colectare de date sau presiune asupra altor utilizatori.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <span className="text-foreground">Mesaje</span>: păstrează un ton respectuos; evită acuzații publice sau
                situații conflictuale. Folosește canalele oficiale ale școlii pentru sesizări disciplinare.
              </li>
              <li>
                <span className="text-foreground">Fișiere și imagini</span>: nu trimite documente ce conțin date sensibile
                (ex.: acte de identitate, date medicale, date bancare). Dacă o situație impune, folosește canale securizate
                aprobate de școală.
              </li>
              <li>
                <span className="text-foreground">Valabilitate link descărcare</span>: pentru protecția datelor, linkurile
                de descărcare a fișierelor din chat au valabilitate limitată (implicit 3 zile, cu posibilitatea de ajustare
                în funcție de implementare).
              </li>
              <li>
                <span className="text-foreground">Raportare</span>: dacă primești conținut abuziv, păstrează contextul (fără
                a redistribui) și raportează administratorului/școlii.
              </li>
            </ul>
          </div>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">6. Comunitate – postări, reacții, comentarii</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Comunitatea este un spațiu școlar: postările trebuie să fie relevante, informative și potrivite mediului
              educațional.
            </li>
            <li>
              Interzis: atac la persoană, rușinare publică, conținut instigator la ură, dezinformare, conținut neadecvat
              minorilor, materiale fără drepturi.
            </li>
            <li>
              Comentariile trebuie să fie constructive. Reacțiile (like/inimă etc.) nu se folosesc pentru hărțuire sau
              coordonare de comportamente toxice.
            </li>
            <li>
              Conținutul poate fi moderat (ascuns/șters) și utilizatorii pot fi sancționați în caz de încălcări repetate.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">7. Bibliotecă și resurse (cărți, fișiere, materiale)</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Încarcă doar materiale pentru care ai drept de distribuire (resurse proprii, materiale cu licență permisivă,
              resurse aprobate de școală).
            </li>
            <li>
              Este interzisă încărcarea de conținut piratat (manuale scanate fără licență, cărți PDF neautorizate, etc.).
            </li>
            <li>
              Dacă Platforma include flux de aprobare (ex.: „în așteptare”), respectă procesul și nu încerca să forțezi
              publicarea.
            </li>
            <li>
              Raportează conținutul care încalcă drepturi sau regulile comunității.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">8. Catalog, note, absențe și confidențialitate</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Datele din catalog (note, absențe, observații) sunt confidențiale. Accesul se face pe roluri și doar pentru
              persoanele îndreptățite.
            </li>
            <li>
              Este interzisă distribuirea publică a datelor din catalog (inclusiv capturi de ecran) fără acord/temei legal.
            </li>
            <li>
              Erorile sau neconcordanțele se semnalează profesorului/administratorului, fără expunere publică.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">9. Calendar, programări și evenimente</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Creează programări relevante și corecte (fără suprapuneri intenționate, invitații excesive sau notificări
              abuzive).
            </li>
            <li>
              Evenimentele trebuie să respecte calendarul școlar și procedurile interne (de ex. aprobări, comunicări).
            </li>
            <li>Nu folosi programările pentru a colecta date personale sau pentru comunicare comercială.</li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">10. Clasa online (audio/video) și chatul clasei</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>Respectă regulile profesorului privind microfonul/camera și conduita în timpul orei.</li>
            <li>
              Este interzisă înregistrarea sau redistribuirea lecțiilor fără permisiunea explicită a școlii și a
              participanților, dacă este cazul.
            </li>
            <li>
              Chatul clasei este pentru întrebări, clarificări și anunțuri. Spam-ul, hărțuirea și conținutul neadecvat sunt
              sancționabile.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">11. Teme, cursuri, fișiere și predări</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Elevii transmit teme doar în formatul cerut. Nu încărca fișiere executabile sau conținut periculos.
            </li>
            <li>
              Profesorii pot furniza feedback și resurse. Toate materialele încărcate trebuie să respecte drepturile de
              autor și confidențialitatea.
            </li>
            <li>
              Încercările de fraudă (copiere, plagiat, falsificare) pot duce la măsuri disciplinare, conform regulilor
              școlii.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">12. Notificări</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Notificările sunt pentru informare rapidă despre activități relevante. Nu le folosi pentru presiune,
              hărțuire sau conținut neadecvat.
            </li>
            <li>
              Anumite notificări pot fi limitate sau dezactivate în funcție de planul de acces sau de setările școlii.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">13. Securitate, confidențialitate și bune practici</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>Folosește parole unice și puternice; nu reutiliza parole din alte servicii.</li>
            <li>Deloghează-te de pe dispozitive publice și nu salva parola în browsere partajate.</li>
            <li>
              Nu trimite în chat parole, coduri, date bancare sau documente de identitate. Pentru situații sensibile,
              contactează școala prin canalele oficiale.
            </li>
            <li>
              Pentru detalii despre prelucrarea datelor, consultă Politica de confidențialitate, GDPR și Politica de
              cookies.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">14. Moderare, măsuri și sancțiuni</h2>
          <div className="space-y-3 text-muted-foreground">
            <p>
              Pentru protejarea comunității și a minorilor, putem aplica măsuri proporționale în funcție de gravitatea
              încălcării.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Avertisment și solicitare de corectare/ștergere.</li>
              <li>Limitarea temporară a funcționalităților (ex.: comentarii, trimitere mesaje, încărcări).</li>
              <li>Suspendarea contului (temporar) sau dezactivarea (în cazuri grave ori repetate).</li>
              <li>Ștergerea conținutului care încalcă regulile.</li>
              <li>Notificarea unității de învățământ și/sau a autorităților, când este necesar.</li>
            </ul>
          </div>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">15. Raportare, sesizări și contact</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Pentru raportarea unui incident, folosește canalele interne ale școlii (diriginte, administrator) și/sau
              pagina de Contact din Platformă.
            </li>
            <li>
              Pentru sesizări privind încălcări ale regulilor Platformei, ne poți scrie la{' '}
              <span className="text-foreground">office@globallinknet.ro</span>.
            </li>
            <li>
              Te rugăm să incluzi: rolul tău, școala/clasa (dacă e cazul), o descriere clară și dovezi relevante (fără a
              redistribui public conținutul problematic).
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">16. Păstrarea conținutului și audit</h2>
          <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
            <li>
              Platforma poate păstra jurnalizări tehnice (loguri) pentru securitate, depanare, prevenirea fraudei și
              conformitate.
            </li>
            <li>
              Mesajele și conținutul pot fi păstrate conform Politicii de confidențialitate și configurațiilor aplicabile
              (de ex. perioade de retenție, politici ale școlii).
            </li>
            <li>
              Ștergerea conținutului din interfață nu garantează eliminarea imediată din copii de siguranță sau din loguri,
              acolo unde legea permite/impune păstrarea pentru o perioadă.
            </li>
          </ul>
        </section>

        <section className="space-y-3 text-sm">
          <h2 className="text-lg font-semibold">17. Modificarea regulamentului</h2>
          <p className="text-muted-foreground">
            Putem actualiza regulamentul pentru a reflecta schimbări funcționale, cerințe legale sau măsuri suplimentare
            de protecție. Versiunea publicată în Platformă este cea aplicabilă la momentul utilizării.
          </p>
        </section>

        <div className="rounded-lg border border-border bg-muted p-4 text-xs text-muted-foreground">
          Acest document are rol informativ și trebuie adaptat/validat juridic în funcție de implementare, politicile
          unităților de învățământ și configurațiile comerciale.
        </div>
      </div>
    </div>
  );
};

export default PlatformRegulation;
